import React, { useState } from 'react';
import Styles from './BancoDoAuto25Banner.css';
import Container from '@/components/atoms/Container';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function BancoDoAuto25Banner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          <picture>
            <source type="image/webp" srcSet="assets/banco-do-auto25/banners/bg-banner.webp" />
            <source type="image/png" srcSet="assets/banco-do-auto25/banners/bg-banner.png" />
            <img
              src="assets/banco-do-auto25/banners/bg-banner.png"
              alt="Homem branco de camisa xadrez vermelha comprando um veiculo e realizando um financiamento na Santander financiamento."
            />
          </picture>
          {/* {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/banco-do-auto25/banners/bg-banner-mobi.webp" />
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/banners/bg-banner-mobi.png"
                  />
                  <img src="assets/banco-do-auto25/banners/bg-banner-mobi.png" alt="" />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/banco-do-auto25/banners/bg-banner-desk.webp" />
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/banners/bg-banner-desk.png"
                  />
                  <img src="assets/banco-do-auto25/banners/bg-banner-desk.png" alt="" />
                </picture>
              )}
            </>
          )} */}
        </div>
        {/* <div className="fade-banner" /> */}
        <div className="fade-banner-gradiente" />
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <p className="main-text">Financiamento de veículos</p>
              <p className="alt-text">
                A Santander Financiamentos ajuda você a conquistar esse sonho em poucos passos.
              </p>
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=banco-do-auto:banner&int_campaign=simular-financiamento"
                target="_blank"
                rel="noopener"
                className="btn-simulate"
              >
                Simular
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default BancoDoAuto25Banner;
